import dxChart from "devextreme/viz/chart";
import dxForm from "devextreme/ui/form";
import dxDataGrid from "devextreme/ui/data_grid";
import dxPivotGrid from "devextreme/ui/pivot_grid";
/*
function createEnum<T extends { [P in keyof T]: P }>(o: T) {
    return o
}
const KeyboardEventKeys = createEnum({ // typed as { Escape: "Escape"; Enter: "Enter"; Tab: "Tab"; }

    Escape: 'Escape',
    Enter: 'Enter',
    Tab: 'Tab'
});

type KeyboardEventKeys = keyof (typeof KeyboardEventKeys);
*/


/*
export const ReportParts = Object.freeze({
    Parameters: "Parameters",
    Header: "Header",
    Data: "Data",
    Footer: "Footer",
});
*/
/*
export const ReportParts = {
    Parameters: "Parameters",
    Header: "Header",
    Data: "Data",
    Footer: "Footer",
} as const;

export type TypeOfReportParts = typeof String [keyof typeof ReportParts]
*/
//export type ReportParts = typeof ReportParts[keyof typeof ReportParts]
//export type TypeOfReportParts = typeof ReportParts[keyof typeof ReportParts]
//export type TypeOfReportParts = typeof ReportParts, string;
//export type ReportParts = keyof typeof ReportParts;

//type ReportParts = [keyof ReportParts, string];
/*
export interface ReportParts {
    Parameters: string,
    Header: string,
    Data: string,
    Footer: string,
}

*/
//export type ReportParts = "Parameters" | "Header" | "Data" | "Footer";
//export type TypeOfReportParts = keyof ReportParts;

/*
interface Person {
    name: string;
    age: number;
    location: string;
}

type K1 = keyof Person; // "name" | "age" | "location"
type K2 = keyof Person[];  // "length" | "push" | "pop" | "concat" | ...
type K3 = keyof { [x: string]: Person };  // string

let k: K1= 

export enum A {
    Id = "string",
    Name = "Name",
};

export interface ENNAME {
    [k: keyof A]: string,
}
let e: ENNAME = A.Id;

export type B = keyof typeof A;
export interface IA{
    Id: string,
    Name: string,
}
type C = {
    [key in keyof IA]: boolean
}
interface D extends C { }
//let a: A = A.Data;
let b: B = A.Id
//let c: D = Id;

type Bar0 = Record<keyof IA, [keyof typeof IA]>;


type Bar = Record<keyof IA, typeof IA>;
let b1: Bar = 
*/
export enum ReportParts {
    Parameters = "Parameters",
    Header = "Header",
    Data = "Data",
    Footer = "Footer",
};

export type TypeOfReportParts = keyof typeof ReportParts;
export interface IReportOneUIComponent {
    type: "dxDataGrid" | "dxPivotGrid" | "dxChart" | "dxForm" | "dxPivotGridWithChart" | null | undefined;
    title: string;
    component: dxDataGrid | dxPivotGrid | dxChart | dxForm | null | undefined;
    reportPart: TypeOfReportParts | null | undefined;
    indexInReportPart: number | null | undefined;
}

